import React, { useState, useEffect } from 'react';
import { useHistory, useLocation, useParams } from "react-router-dom";
import CommonPopup from '../../Component/CommonPopup/CommonPopup';
import "../../Component/CommonPopup/commonPopup.css"
import { Button } from 'antd';
const ErrorPopup = (props) => {

    const history = useHistory();

    const [isCommonPopupOpen, setIsCommonPopupOpen] = useState(false);
    const [popupTitle, setPopupTitle] = useState("");
    const [popupMsg, setPopupMsg] = useState("");
    const [popupType, setPopupType] = useState("");
    const [popupActionType, setPopupActionType] = useState("");
    const [popupActionValue, setPopupActionValue] = useState("");
    const [popupActionPath, setPopupActionPath] = useState("");
    const [alertmessage, setAlertMessage] = useState("");
    const [alerttitle, setAlertTitle] = useState("");
    const [alertimg, setAlertImg] = useState("");
    // const [comments,setComments] = useState(props.viewArbId);
    const [commentsError, setCommentsError] = useState("");
    const [togglePopupOpen, setTogglePopupOpen] = useState(true);
    const [notesList, setNotesList] = useState("");
    const [arb, setArb] = useState();

    return (
        <div className="popup-box">
            <div id="" className="CommonModels-box">
                <div className="Commonfullformblock col-lg-9">
                    <div className="CommonContainer">
                        <div className="CommonModalcontent">
                            {togglePopupOpen &&
                                (<>
                                    <div className="">
                                        <div class="error-oopspop">
                                            <i class="icofont-warning"></i>
                                            <p>Something Went Wrong</p>
                                        </div>
                                        {/* <h5 class="text-color mb-4 mt-4">Arb</h5> */}
                                        <div className='page-fourerrorpop'>
                                            <p>{props.error}</p>

                                        </div>
                                        <div className='page-messagepop'>
                                            {props.error === "Unauthorized User" ?
                                                <p>Unauthorized User Exception-You do not have the Authorization to access this page.For more queries Contact URSecondLot Admin info@ur2ndlot.com.</p> :
                                                <p>There was a problem processing the request. For more queries Contact URSecondLot Admin info@ur2ndlot.com.</p>}
                                        </div >
                                    </div>
                                    <div className="CommonModalfooter ">
                                        <div className="CommonModalfooter session">
                                            <button onClick={() => history.goBack()} class="page-error-buttonpop">Return to last page</button>
                                            {/* <Button className="btn btn-smlprimary" onClick={()=> {saveAdd();props.toggle()}} >Ok</Button>  */}
                                        </div>
                                    </div>
                                </>)}


                        </div>
                    </div>
                </div>
            </div>
            {isCommonPopupOpen && <CommonPopup
                handleClose={isCommonPopupOpen}
                popupTitle={popupTitle}
                popupMsg={popupMsg}
                popupType={popupType}
                popupActionType={popupActionType}
                popupActionValue={popupActionValue}
                popupActionPath={popupActionPath}
            />}
        </div>
    )
}

export default ErrorPopup